import React from 'react'
import PropTypes from 'prop-types'

import * as firebase from 'firebase'
import _ from 'lodash'
import { connect } from 'react-redux'

import InvoiceItem from './InvoiceItem'
import InvoiceItemEdit from './InvoiceItemEdit'
import DeleteInvoiceItemDialog from './DeleteInvoiceItemDialog'

class InvoiceItemsList extends React.Component {

  static propTypes = {
    style: PropTypes.object.isRequired,
    teamId: PropTypes.string.isRequired,
    defaultInvoiceItems: PropTypes.object
  }

  constructor(props) {
    super(props)
    this.state = {
      showDeleteConfirmationDialog: false,
      adding: false
    }
  }

  handleInvoiceItemEdit = (event, invoiceItem) => {
    event.preventDefault()
    this.setState({
      editInvoiceItemKey: invoiceItem.dbKey,
      adding: false
    })
  }

  handleInvoiceItemAddClicked = event => {
    event.preventDefault()
    this.setState({
      adding: true,
      editInvoiceItemKey: null
    })
  }

  handleInvoiceItemDelete = (event, invoiceItem) => {
    event.preventDefault()
    this.setState({
      showDeleteConfirmationDialog: true,
      deleteInvoiceItemKey: invoiceItem.dbKey,
      adding: false
    })
  }

  handleDeleteConfirmationResult = result => {
    if (result) {
      firebase.database()
        .ref(`teams/${this.props.teamId}/defaultInvoiceItems/${this.state.deleteInvoiceItemKey}`)
        .set(null)
    }
    this.setState({ showDeleteConfirmationDialog: false })
  }

  handleAddInvoiceItem = invoiceItem => {
    const dbRef = firebase.database().ref(`teams/${this.props.teamId}/defaultInvoiceItems`)
    const key = dbRef.push().key
    dbRef.child(key).set(invoiceItem)
    this.setState({ adding: false })
  }

  handleSaveInvoiceItem = invoiceItem => {
    firebase.database()
      .ref(`teams/${this.props.teamId}/defaultInvoiceItems/${this.state.editInvoiceItemKey}`)
      .set(invoiceItem)
    this.setState({ editInvoiceItemKey: null })
  }

  handleDeleteConfirmationCancelled = () => {
    this.setState({ showDeleteConfirmationDialog: false })
  }

  render() {
    const invoiceItems = this.props.defaultInvoiceItems && _.map(this.props.defaultInvoiceItems, (value, dbKey) => ({ ...value, dbKey })) || []
    return (
      <div style={this.props.style}>
        { invoiceItems.length
          ? <div>
            <div style={styles.listHeaderContainer}>
              <div style={{ ...styles.listHeader(true), ...styles.listMainWidth }}>Name</div>
              <div style={{ ...styles.listHeader(), ...styles.listMinorWidth }}>Quantity</div>
              <div style={{ ...styles.listHeader(), ...styles.listMinorWidth }}>Rate</div>
              <div style={{ ...styles.listHeader(), ...styles.listMinorWidth }}>Tax %</div>
              <div style={{ ...styles.listHeader(), ...styles.listIconWidth }}></div>
            </div>
            { invoiceItems.map((invoiceItem, index) =>
              invoiceItem.dbKey === this.state.editInvoiceItemKey
                ? <InvoiceItemEdit
                  key={index} index={index} invoiceItem={invoiceItem}
                  onSave={this.handleSaveInvoiceItem}/>
                : <InvoiceItem key={index} index={index} invoiceItem={invoiceItem}
                  onEditClicked={event => this.handleInvoiceItemEdit(event, invoiceItem)}
                  onDeleteClicked={event => this.handleInvoiceItemDelete(event, invoiceItem)} />)
            }
          </div>
          : <div style={styles.empty}>No invoice items added yet.</div>
        }
        { this.state.adding
          ? <InvoiceItemEdit
            key='add' index={invoiceItems.length}
            style={styles.add}
            onSave={this.handleAddInvoiceItem}/>
          : <div style={styles.add} onTouchTap={this.handleInvoiceItemAddClicked}>Add invoice item ...</div>
        }
        { this.state.showDeleteConfirmationDialog
          && <DeleteInvoiceItemDialog
            open={this.state.showDeleteConfirmationDialog}
            onDialogResult={this.handleDeleteConfirmationResult}
            onRequestClose={this.handleDeleteConfirmationCancelled} />
        }
      </div>
    )
  }

}

const styles = {
  listHeaderContainer: {
    display:'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    borderBottom: '1px solid #527da3'
  },
  listHeader: isName => ({
    color: '#757575',
    fontWeight: 500,
    fontSize: 14,
    paddingBottom: 8,
    marginLeft: isName ? 16 : 0
  }),
  listMainWidth: {
    width: 250
  },
  listMinorWidth: {
    width: 75
  },
  listIconWidth: {
    width: 44
  },
  add: {
    cursor: 'pointer',
    color: '#356992',
    fontSize: 14,
    marginTop: 18
  },
  empty: {
    fontSize: 14,
    fontWeight: 300
  }
}

const mapStateToProps = state => ({
  teamId: state.firebase.team.metadata.value.id,
  defaultInvoiceItems: state.firebase.team.defaultInvoiceItems.value
})

export default connect(mapStateToProps)(InvoiceItemsList)



// WEBPACK FOOTER //
// ./src/settings/modules/invoiceItems/InvoiceItemsList.js